import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import logo from "../../assets/images/PiChain-logo.png";
import "../../css/layout.css"

const Footer = ({ className }) => {
  return (
    <Box className={`footerRoot marginVertical-md ${className || ""}`}>
      <Typography align="center" variant="body2">
        Powered by
      </Typography>
      <Box display="flex" justifyContent="center" mt={1}>
        <img className="companylogo" src={logo} alt="www.pichainlabs.com" />
      </Box>
    </Box>
  );
};

Footer.propTypes = {
  className: PropTypes.string,
};

export default Footer;
